import { Link } from 'react-router-dom';
import type { Work } from '@/mocks/works';
import { typeLabel } from '@/utils/works';

export default function RelatedWorks({ works, currentId }: { works: Work[]; currentId: string }) {
  const list = works.filter((w) => w.id !== currentId);
  if (list.length === 0) return null;

  return (
    <section className="mt-10">
      <div className="flex items-center gap-3 mb-5">
        <span className="w-10 h-10 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center text-xl">
          <i className="ri-magic-line" aria-hidden="true"></i>
        </span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950">相关推荐</h2>
          <p className="mt-0.5 text-xs text-foreground-500">根据类型与主演为你匹配</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {list.slice(0, 5).map((work) => (
          <Link key={work.id} to={`/detail/${work.id}`} className="group block cursor-pointer">
            <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src={work.cover}
                alt={`${work.title} 封面`}
                title={`${work.title} ${typeLabel(work.type)}`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute top-2 right-2 flex items-center gap-0.5 px-2 py-0.5 rounded-md text-[11px] font-medium bg-accent-500 text-secondary-950">
                <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
                {work.rating.toFixed(1)}
              </span>
            </div>
            <h3 className="mt-2.5 text-sm font-medium text-foreground-900 truncate group-hover:text-primary-700 transition-colors">
              {work.title}
            </h3>
            <p className="mt-1 text-xs text-foreground-500 truncate">
              {work.year} · {work.genres.join(' / ')}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}